<template lang="pug">
  .admin-managers
    .admin-managers__title
      h1.title Контент-менеджеры
    .admin-managers__content
      .admin-managers__button
        router-link.button.button_paint-main--transparent(
        to="/administrator/managers-create"
        ) Создать учетную запись
      .admin-managers__table
        admin-table(
        :tab_data="test"
        )
      .admin-managers__pagination
        admin-table-pagination

</template>

<script>
import AdminTablePagination from "../components/admin-table-pagination.vue";
import AdminTable from "./components/admin-managers-table.vue";

export default {
  name: "admin-managers",

  components: {
    AdminTable,
    AdminTablePagination,
  },
  data() {
    return {
      test: [
        {
          name: "Султанов Рамиль Рустамович",
          id: 1,
        },
        {
          name: "Султанов Рамиль Рустамович",
          id: 2,
        },
        {
          name: "Султанов Рамиль Рустамович",
          id: 3,
        },
      ],
    };
  },
};
</script>
